/* 导航栏交互，配套 sections/header.liquid：菜单开关、搜索框展开、账户注册弹窗、
   已登录账户小卡片。全部走 document 级事件委托，这样 Shopify 主题编辑器重新
   渲染 section 后无需重新绑定。 */
(function () {
  function closeAccountModal() {
    const modal = document.querySelector('[data-account-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('account-modal-open');
  }

  /* 已登录时才存在的账户卡片（邮箱 + Orders / Profile） */
  function closeAccountMenu() {
    const menu = document.querySelector('[data-account-menu].is-open');
    if (!menu) return;
    menu.classList.remove('is-open');
    const toggle = menu.querySelector('[data-account-menu-toggle]');
    const panel = menu.querySelector('[data-account-menu-panel]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('[data-menu-toggle]');
    const searchToggle = event.target.closest('[data-search-toggle]');
    const accountOpen = event.target.closest('[data-account-open]');
    const accountClose = event.target.closest('[data-account-close]');
    const accountMenuToggle = event.target.closest('[data-account-menu-toggle]');
    const accountMenuClose = event.target.closest('[data-account-menu-close]');

    if (menuToggle) {
      document.querySelector('[data-mobile-menu]')?.classList.toggle('is-open');
    }

    if (searchToggle) {
      event.preventDefault();
      const search = searchToggle.closest('[data-header-search]');
      search?.classList.add('is-open');
      search?.querySelector('input')?.focus();
    }

    if (accountMenuToggle) {
      event.preventDefault();
      const wrapper = accountMenuToggle.closest('[data-account-menu]');
      if (wrapper) {
        const willOpen = !wrapper.classList.contains('is-open');
        closeAccountModal();
        wrapper.classList.toggle('is-open', willOpen);
        accountMenuToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        const panel = wrapper.querySelector('[data-account-menu-panel]');
        if (panel) panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
      }
      return;
    }

    if (accountMenuClose) {
      closeAccountMenu();
      return;
    }

    if (!event.target.closest('[data-account-menu]')) closeAccountMenu();

    if (accountOpen) {
      event.preventDefault();
      const modal = document.querySelector('[data-account-modal]');
      if (modal) {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('account-modal-open');
        modal.querySelector('input[type="email"]')?.focus();
      }
    }

    if (accountClose) {
      closeAccountModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelector('[data-header-search]')?.classList.remove('is-open');
    closeAccountModal();
    closeAccountMenu();
  });
})();
